import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useMemo } from "react";
import { ExperiencesSearchView } from "@/lib/features/ExperiencesSearchView";
import { searchPageSearchSchema } from "@/lib/schemas/searchParams.schema";
import { trpc } from "@/router";
import { jsx as _jsx } from "react/jsx-runtime";
export const Route = createFileRoute("/_public/upplevelser/sok")({
  validateSearch: searchPageSearchSchema,
  component: SearchPageContent
});
function SearchPageContent() {
  const $ = _c(9);
  const {
    q: t0
  } = Route.useSearch();
  const query = t0 === undefined ? "" : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = trpc.experiences.public.queryOptions({});
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: experiences
  } = useQuery(t1);
  let t2;
  bb0: {
    if (!experiences || !query) {
      let t3;
      if ($[1] !== experiences) {
        t3 = experiences ?? [];
        $[1] = experiences;
        $[2] = t3;
      } else {
        t3 = $[2];
      }
      t2 = t3;
      break bb0;
    }
    let t3;
    if ($[3] !== experiences || $[4] !== query) {
      const q = query.toLowerCase();
      t3 = experiences.filter(exp => {
        const titleMatch = exp.title.toLowerCase().includes(q);
        const subtitleMatch = exp.subtitle?.toLowerCase().includes(q) ?? false;
        const descriptionMatch = exp.description?.toLowerCase().includes(q) ?? false;
        return titleMatch || subtitleMatch || descriptionMatch;
      });
      $[3] = experiences;
      $[4] = query;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = t3;
  }
  const searchResults = t2;
  let t3;
  if ($[6] !== query || $[7] !== searchResults) {
    t3 = /*#__PURE__*/_jsx(ExperiencesSearchView, {
      experiences: searchResults,
      query: query
    });
    $[6] = query;
    $[7] = searchResults;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}